import { initContract } from "@ts-rest/core";
import {
	createResourceInput,
	findResourceFilter,
	PaginatedCreateResourceDto,
	deleteResource,
	publishResourceInput,
} from "../validators/resources.validators";

const c = initContract();

export const resourcesContract = c.router({
	getResources: {
		method: "GET",
		path: "/resources",
		responses: {
			200: c.type<PaginatedCreateResourceDto>(),
		},
		query: findResourceFilter,
	},

	createResource: {
		method: "POST",
		path: "/resources",
		body: createResourceInput,
		responses: {
			200: c.type<PaginatedCreateResourceDto>(),
		},
	},
	updateResources: {
		method: "PUT",
		path: "/resources/:resourceId",
		body: createResourceInput,
		responses: {
			200: c.type<PaginatedCreateResourceDto>(),
		},
	},
	deleteResource: {
		method: "DELETE",
		path: "/resources/:resourceId",
		body: deleteResource,
		responses: {
			204: c.type<void>(),
		},
	},
	updatePublishResource: {
		method: "PUT",
		path: "/resources/publish/:resourceId",
		body: publishResourceInput,
		responses: {
			200: c.type<PaginatedCreateResourceDto>(),
		},
	},
});
